// Central registry of column names that represent monetary values.
// Keep in sync with backend/table column names. Prefer adding here over
// ad-hoc "$" prefixes at call sites so formatting stays consistent app-wide.

export const CURRENCY_FIELDS: ReadonlySet<string> = new Set([
  "cost",
  "revenue",
  "total_cost",
  "unit_cost",
]);

export const isCurrencyField = (col: string | undefined): boolean =>
  !!col && CURRENCY_FIELDS.has(col);

const DECIMAL_FIELDS: ReadonlySet<string> = new Set(["unit_cost"]);

const wholeDollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencySign: "accounting",
  maximumFractionDigits: 0,
});

const centsFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencySign: "accounting",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// Inject a space between the "$" and the number for accounting-style legibility
// (e.g. "$ 1,000" and "($ 1,000)"). Intl.NumberFormat has no native option for
// this in en-US, so we post-process the single "$" occurrence.
const withSpacedSymbol = (formatted: string): string =>
  formatted.replace("$", "$ ");

export const formatCurrency = (value: number, col?: string): string => {
  const formatter =
    col && DECIMAL_FIELDS.has(col) ? centsFormatter : wholeDollarFormatter;
  return withSpacedSymbol(formatter.format(value));
};
